import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import { useOnSiteStructureChanged } from "../../../hooks/useOnSiteStructureChanged";
import urls from "../../../urls";
import { COMPONENT_QUERY_KEY } from "../../../utils/constants";
import { ObjectName } from "../../../utils/enums";
import type {
  MeteringConceptMeterFieldsResponse,
  MeteringConceptMeterFieldsUpdateRequest
} from "../Meter.types";
import { meterQueries } from "./useMeter";
import { meteringConceptMeterQueries } from "./useMeteringConceptMeter";

export function useMeteringConceptMeterMutation(
  meterId: number,
  siteId: number
) {
  const queryClient = useQueryClient();
  const cacheName = COMPONENT_QUERY_KEY[ObjectName.Meter];
  const onSiteStructureChanged = useOnSiteStructureChanged(siteId);

  const editMutation = useMutation({
    mutationFn: (
      updatedData: Partial<MeteringConceptMeterFieldsUpdateRequest>
    ) => updateMeteringConceptMeter(meterId, updatedData),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: meteringConceptMeterQueries.detail(meterId).queryKey
      });
      queryClient.invalidateQueries({
        queryKey: meterQueries.detail(meterId).queryKey
      });
      queryClient.invalidateQueries({
        queryKey: [cacheName, { siteOrVariantId: siteId }]
      });
      onSiteStructureChanged();
    }
  });

  return { editMutation };
}

function updateMeteringConceptMeter(
  meterId: number,
  data: Partial<MeteringConceptMeterFieldsUpdateRequest>
) {
  const url = urls.apiWithoutCamelization.meteringConceptMeter(meterId);
  return apiWithoutCamelization.patch<MeteringConceptMeterFieldsResponse>(
    url,
    data
  );
}
